import React, { useState, useEffect, useMemo } from 'react';
import { useReactTable, flexRender, getCoreRowModel } from "@tanstack/react-table";
import axios from "axios";
import { Auth } from 'aws-amplify';
import * as env from "../../../environment";

const { API_URL_BACKEND } = env[process.env.NODE_ENV];
const registrosPorPagina = 10

const refreshToken = async () => {
    try {
        const session = await Auth.currentSession();
        console.log("session", session)
        console.log("access token", session.accessToken.jwtToken)
        localStorage.setItem("token", session.accessToken.jwtToken);
    } catch (e) {
        localStorage.clear();
        window.location = '/';
    }
};


function TablaComponent({ idPeriodo }) {
    const [data, setData] = useState([]);
    const [lastPage, setLastPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginasPrevias, setPaginasPrevias] = useState([]);
    const [paginasPosteriores, setPaginasPosteriores] = useState([]);
    const [etcIzq, setEtcIzq] = useState(false);
    const [etcDer, setEtcDer] = useState(false);

    const [loading, setLoading] = useState(false)

    const fetchPosts = async (pagina, periodoId) => {
        pagina = pagina - 1;
        //Si periodoId > 0, busco el reporte
        if (periodoId > 0) {
            await refreshToken();
    
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    AuditUser: `${localStorage.getItem('user')}`
                }
            };
    
            const endpoint = `${API_URL_BACKEND}/report/despachodigital/${periodoId}/${pagina}/${registrosPorPagina}`
    
            console.log("Llamando al endpoint [" + endpoint + "] con el config [" + config + "]")
    
            setLoading(true)
            let respuesta = []
            
            try {
                const response = await axios.get(endpoint, config)
                if (response.status === 200) {
                    console.log("Respuesta", response.data)
                    respuesta = response.data
                } else {
                    alert("error " + response.status + " : " + response.message)
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
    
            setLoading(false)
            return respuesta
        }
    }

    useEffect(() => {

        console.log("Actualizamos las paginas anteriores y posteriores")
        let lasPaginasPrevias = []
        for(let i=currentPage - 5; i < currentPage; i++) {
            if(i > 0) {
                lasPaginasPrevias.push(i)
            }
        }
        if(lasPaginasPrevias.length > 0) {
            if(lasPaginasPrevias[0] === 1) {
                console.log("no hay nada a la izquierda ", lasPaginasPrevias.length)
                setEtcIzq(false)
            } else {
                console.log("puntitos a la izquierda ")
                setEtcIzq(true)
            }
        } else {
            setEtcIzq(false)
        }
        
        setPaginasPrevias(lasPaginasPrevias)

        let lasPaginasPosteriores = []
        for(let i=currentPage + 1; i < currentPage + 5 + 1; i++) {
            if(i < lastPage + 1) {
                lasPaginasPosteriores.push(i)
            }

        }
        if(lasPaginasPosteriores.length > 0) {
            console.log("El ultimo elemento ", lasPaginasPrevias[lasPaginasPosteriores.length-1], "comparado con ", lastPage)
            if(lasPaginasPosteriores[lasPaginasPosteriores.length-1] === lastPage) {
                setEtcDer(false)
            } else {
                setEtcDer(true)
            }
        } else {
            setEtcDer(false)
        }
        
        setPaginasPosteriores(lasPaginasPosteriores)

        //Obtenemos la data para esta nueva pagina
        fetchPosts(currentPage, idPeriodo).then((response) => {
            setData(response.data);
            setLastPage(response.pagination.total_pages);
        });
    }, [currentPage, idPeriodo, lastPage]);

    const columns = useMemo(
        () => [
            {
                accessorFn: (row) => row.id,
                id: "post.id",
                header: "ID",
                cell: (info) => info.getValue(),
            },
            {

                accessorFn: (row) => row.periodo.mes,
                id: "post.periodo.mes",
                header: "Mes",
                style: { whiteSpace: "unset", paddingTop: 15 },
            },
            {
                header: "Año",
                accessorFn: (row) => row.periodo.anio,
                id: "post.periodo.anio",
                //sortable: false,
                //width: 50,
                style: { whiteSpace: "unset", paddingTop: 15 },
            },
            {
                accessorFn: (row) => row.correo,
                id: "post.correo",
                header: "Correo",
                cell: (info) => info.getValue(),
            },
            {
                accessorFn: (row) => row.cliente,
                id: "post.cliente",
                header: "Cliente",
                cell: (info) => info.getValue(),
            },
            {
                accessorFn: (row) => row.cuenta,
                id: "post.cuenta",
                header: "Cuenta",
                cell: (info) => info.getValue(),
            },
            { header: "Folio", accessorFn: (row) => row.folio, sortable: false, width: 100, style: { whiteSpace: "unset", paddingTop: 15 } },
            { header: "N° documento", accessorFn: (row) => row.nro_doc, sortable: false, width: 100, style: { whiteSpace: "unset", paddingTop: 15 } },
            {
                header: "Emisión documento",
                accessorFn: (row) => {
                    const original = row.fecha_emision_doc
                    return original ? new Date(original).toLocaleDateString("es-CL") : ''
                }, sortable: false,
                width: 120, style: { whiteSpace: "unset", paddingTop: 15 }
            },
            {
                header: "Distribución", sortable: false,
                accessorFn: (row) => {
                    const original = row.fecha_distribucion
                    return original ? new Date(original).toLocaleString("es-CL") : ''
                },
                width: 120, style: { whiteSpace: "unset", paddingTop: 15 }
            },
            { header: "Estado", accessorFn: (row) => row.estado, sortable: false, width: 100, style: { whiteSpace: "unset", paddingTop: 15 } },
            {
                header: "Fecha estado", sortable: false,
                accessorFn: (row) => {
                    const original = row.fecha_estado
                    return original ? new Date(original).toLocaleString("es-CL") : ''
                },
                width: 120, style: { whiteSpace: "unset", paddingTop: 15 }
            },
            {
                header: "¿Inserto?", sortable: false,
                accessorFn: (row) => {
                    const correoOrig = row.posee_inserto
                    return correoOrig ? "SI" : "NO"
                },
                width: 50, style: { whiteSpace: "unset", paddingTop: 15 }
            },
            {
                header: "¿Anexo Netbilling?",
                accessorFn: (row) => {
                    const correoOrig = row.posee_anx_netbilling
                    return correoOrig ? "SI" : "NO"
                },
                sortable: false, width: 50, style: { whiteSpace: "unset", paddingTop: 15 }
            },
            {
                header: "¿Mal factor de potencia? ",
                accessorFn: (row) => {
                    const correoOrig = row.posee_anx_carta_mfp
                    return correoOrig ? "SI" : "NO"
                },
                sortable: false, width: 50, style: { whiteSpace: "unset", paddingTop: 15 }
            },
            { header: "Unidad de lectura", accessorFn: (row) => row.unidad_lectura, sortable: false, width: 50, style: { whiteSpace: "unset", paddingTop: 15 } },
            {
                header: "ID Programa",
                accessorFn: (row) => row.programa,
                sortable: false,
                width: 150,
                style: { whiteSpace: "unset", paddingTop: 15 },
            },
            {
                header: "Tipo de rebote",
                accessorFn: (row) => row.rebote_tipo,
                sortable: false,
                width: 150,
                style: { whiteSpace: "unset", paddingTop: 15 },
            },
            {
                header: "Subtipo de rebote",
                accessorFn: (row) => row.rebote_subtipo,
                sortable: false,
                width: 150,
                style: { whiteSpace: "unset", paddingTop: 15 },
            },
            {
                header: "Diagnostico",
                accessorFn: (row) => row.diagnostico,
                sortable: false,
                width: 150,
                style: { whiteSpace: "unset", paddingTop: 15 },
            }
        ],
        [],
    );

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        manualPagination: true,
    })

    return (<>
    
    <div class="loader-box">
      {loading && <div class="loader"></div>}
    </div>
    
    <table>
        <thead>
            {table.getHeaderGroups().map(headerGroup => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map(header => (
                        <th key={header.id} colSpan={header.colSpan}>
                            {header.isPlaceholder
                                ? null
                                : flexRender(
                                    header.column.columnDef.header,
                                    header.getContext()
                                )}
                        </th>
                    ))}
                </tr>
            ))}
        </thead>
        <tbody>
            {table.getRowModel().rows.map(row => (
                <tr key={row.id}>
                    {row.getVisibleCells().map(cell => (
                        <td key={cell.id}>
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                    ))}
                </tr>
            ))}
        </tbody>
        <tfoot>
            {table.getFooterGroups().map(footerGroup => (
                <tr key={footerGroup.id}>
                    {footerGroup.headers.map(header => (
                        <th key={header.id} colSpan={header.colSpan}>
                            {header.isPlaceholder
                                ? null
                                : flexRender(
                                    header.column.columnDef.footer,
                                    header.getContext()
                                )}
                        </th>
                    ))}
                </tr>
            ))}
        </tfoot>
    </table>

        <div>
            <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
            >
                Anterior
            </button>
            {etcIzq && <span>...</span>}
            {paginasPrevias.map(nroPagina => (<button onClick={() => setCurrentPage(nroPagina)}>{nroPagina}</button>))}
            <button disabled><b>{currentPage}</b></button>
            {paginasPosteriores.map(nroPagina => (<button onClick={() => setCurrentPage(nroPagina)}>{nroPagina}</button>))}
            {etcDer && <span>...</span>}
            <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === lastPage}
            >
                Siguiente
            </button>
        </div>

    </>)
}

export default TablaComponent;